import React from 'react';

interface LoaderProps {
    fullScreen?: boolean;
    size?: 'sm' | 'md' | 'lg';
}

export const Loader: React.FC<LoaderProps> = ({ fullScreen = false, size = 'md' }) => {
    const sizeClasses = {
        sm: 'w-8 h-8',
        md: 'w-12 h-12',
        lg: 'w-16 h-16'
    };

    const dotSizeClasses = {
        sm: 'w-2 h-2',
        md: 'w-3 h-3',
        lg: 'w-4 h-4'
    };

    if (fullScreen) {
        return (
            <div className="fixed inset-0 z-[999999] flex flex-col items-center justify-center bg-[#1f2937] min-h-screen">
                <img
                    src="/assets/images/logo/logo.svg"
                    alt="codeflix invoice logo"
                    className="h-20 mb-10"
                />
                <div className="flex items-center justify-center space-x-2">
                    <div className={`${dotSizeClasses[size]} bg-[#6366f1] rounded-full animate-bounce`} style={{ animationDelay: '0s' }}></div>
                    <div className={`${dotSizeClasses[size]} bg-[#6366f1] rounded-full animate-bounce`} style={{ animationDelay: '0.2s' }}></div>
                    <div className={`${dotSizeClasses[size]} bg-[#6366f1] rounded-full animate-bounce`} style={{ animationDelay: '0.4s' }}></div>
                </div>
            </div>
        );
    }

    return (
        <div className="flex items-center justify-center">
            <div className="flex items-center justify-center space-x-2">
                <div className={`${dotSizeClasses[size]} bg-[#6366f1] rounded-full animate-bounce`} style={{ animationDelay: '0s' }}></div>
                <div className={`${dotSizeClasses[size]} bg-[#6366f1] rounded-full animate-bounce`} style={{ animationDelay: '0.2s' }}></div>
                <div className={`${dotSizeClasses[size]} bg-[#6366f1] rounded-full animate-bounce`} style={{ animationDelay: '0.4s' }}></div>
            </div>
        </div>
    );
};
